
import { defineComponent, PropType, ref } from "vue";
import {
  ITemplateSet,
  IEditData,
  twoBytwoOrder,
  consts,
  isInvalidTemplate,
} from "@/services/Models";
import TemplateThumbnail from "@/components/TemplateThumbnail.vue";
import ThreeDotsMenu, { IMenuItem } from "@/components/ThreeDotsMenu.vue";
import store from "@/stores";
import { toResourceUrl, microWait, getBase64ImageFromUrl } from "@/lib/shared";
import { useLoading } from "@/lib/loading";

export default defineComponent({
  name: "EditDataThumbnail",
  components: {
    TemplateThumbnail,
    ThreeDotsMenu,
  },
  props: {
    template: { type: Object as PropType<ITemplateSet> },
    editData: { type: Object as PropType<IEditData> },
    isRightMenu: { type: Boolean },
  },
  setup(props) {
    const isEditTitle = ref(false);
    const isShowConfirm = ref(false);
    const isNoTemplate = isInvalidTemplate(props?.template);

    const input = ref<HTMLInputElement>();
    const resource = store.useResource();
    // タイトル編集開始
    const startEdit = async () => {
      isEditTitle.value = true;
      await microWait();
      if (!input.value) return;
      input.value.focus();
    };

    // タイトル編集終了
    const endEdit = async (cancel?: boolean) => {
      if (!isEditTitle.value) {
        return;
      }
      const inputValue = input.value?.value;
      isEditTitle.value = false;
      // 編集内容をクリア
      if (cancel) return;
      if (!inputValue) return;
      if (!props.editData) return;
      // 編集内容を保存
      const json = JSON.stringify(props.editData);
      const duplicated = JSON.parse(json) as IEditData;
      duplicated.title = inputValue;
      if (duplicated.editset != undefined) {
        const src = toResourceUrl(duplicated.editset.thumbnailPath ?? "");
        const dataURL = await getBase64ImageFromUrl(src);
        duplicated.editset.thumbnailImage = dataURL as string;
      }
      resource.saveEditData(duplicated);
    };
    const loading = useLoading();

    // コピーの作成
    const duplicateIt = async () => {
      loading.loadWith(async () => {
        if (!props.editData) return;
        const json = JSON.stringify(props.editData);
        const duplicated = JSON.parse(json) as IEditData;
        // IDを初期化して新規作成対象にする
        duplicated.id = undefined;
        for (const frame of duplicated.frames) {
          frame.id = undefined;
          for (const editObj of frame.items) {
            editObj.id = undefined;
          }
        }
        // コマ入れ替えデータの場合はeditsetも新規生成させるため初期化する
        if (duplicated.editset != undefined) {
          duplicated.editset.id = undefined;
          duplicated.editset.editDataID = undefined;
          const src = toResourceUrl(duplicated.editset.thumbnailPath ?? "");
          const dataURL = await getBase64ImageFromUrl(src);
          duplicated.editset.thumbnailImage = dataURL as string;
          duplicated.editset.thumbnailPath = undefined;
        }
        await resource.saveEditData(duplicated);
      });
    };

    // 編集データの削除
    const deleteIt = async () => {
      isShowConfirm.value = false;
      if (props.editData?.id === undefined) return;
      await resource.deleteEditData(props.editData.id);
    };
    // メニュー要素
    const items: IMenuItem[] = [
      // コピーを作成
      {
        name: consts.menuItemCopy,
        icon: ["far", "copy"],
        clickAction: duplicateIt,
      },
      // 削除
      {
        name: consts.menuItemDelete,
        icon: ["far", "trash-alt"],
        clickAction: async () => {
          isShowConfirm.value = true;
          return Promise.resolve();
        },
      },
    ];

    const itemDelete: IMenuItem[] = [
      {
        name: consts.menuItemDelete,
        icon: ["far", "trash-alt"],
        clickAction: async () => {
          isShowConfirm.value = true;
          return Promise.resolve();
        },
      },
    ];

    return {
      isEditTitle,
      startEdit,
      endEdit,
      deleteIt,
      input,
      items,
      itemDelete,
      isShowConfirm,
      isNoTemplate,
      toResourceUrl,
      twoBytwoOrder,
      consts,
    };
  },
});
